/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { RestApiOptions } from './types';

export const createAvailabilityBlocksRepository = (options: RestApiOptions): Types.AvailabilityBlocksRepository => ({
    async getAll(params, requestOptions) {
        return options.request('/availabilityBlocks/getAll', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
